export enum RoutePath {
  Confirmation = '/confirmation',
  Basket = '/details',
  Home = '/',
  Payment = '/payment',
  Personalise = '/personalise',
}
